import { $qs, $qsa } from '../../utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);


function progressBar() {
    const progressBar = $qsa('[data-name="progress-bar"]');

    if (!progressBar) return;

let animation = gsap.fromTo(progressBar,{scaleY: 0.2},{scaleY: 1, transformOrigin: 'top'})

    let pinProgress = ScrollTrigger.create({
		trigger: '[data-name="progress-bar-contain"]',
		pin: progressBar,
		pinSpacing: false,
		start: "top top",
		end: "bottom bottom",
		markers: false,
        scrub: true,
        animation: animation
	   
	  });


}

function bannerPost(){
    progressBar();
}

export default bannerPost;